import { Time } from '@angular/common';
import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import * as TimeSpan from 'timespan';

export interface VideoAppointmentsParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface VideoAppointment {
    Id:any ;
    AppointmentId:any  ;
    DoctorId:any ;
    RegId:any  ;
    StartTime:Date  ;
    EndTime:Date ;
    InvitationSend:string ;
    VisitId:any;
    EventStatus:string ;
    InvitationUrl:string;
    Roomno:string ;
    Duration:number;
    RecordUrl:any ;
    TenantId:any ;
    BranchId:any ;
    TokenId:any;
    Date:Date ;
    Active_Flag:string ;
    CreatedBy:string ;
    CreatedDate:Date ;
    doctorIP: string;
    doctorDeviceType: string;
    doctorOS: string;
    doctorBrowser: string;
    doctorBrowserVersion: string;
    patientIP: string;
    patientDeviceType: string;
    patientOS: string;
    patientBrowser: string;
    patientBrowserVersion: string;
}


export abstract class VideoAppointmentsData {
     abstract getById(url: string): Observable<any>;
     abstract list(url: string): Observable<any[]>;
     abstract create(url: string, data: any): Observable<any>;
     abstract update(url: string, data: VideoAppointment): Observable<VideoAppointment>;
     abstract delete(url: string): Observable<any>;
}

